<div *ngIf="message.data.text || message.data.attachmentName" class="pa-message-content pa-message-content-text">
    <div *ngIf="message.data.text" [innerHTML]="message.data.text | emoji | markdown" class="pa-message-text"></div>
    <div *ngIf="message.data.attachmentName" class="pa-message-attachment">
        <svg aria-hidden="true" class="pa-message-attachment-icon" viewBox="0 0 24 24" role="img">
            <path fill="currentColor"
                  d="M16.5 6.5v9a4.5 4.5 0 1 1-9 0V5a3 3 0 0 1 6 0v9.5a1.5 1.5 0 1 1-3 0V6.5H9V14.5a3 3 0 0 0 6 0V5a4.5 4.5 0 0 0-9 0v10.5a6 6 0 1 0 12 0v-9h-1.5z"/>
        </svg>
        <span class="pa-message-attachment-name">{{ message.data.attachmentName }}</span>
    </div>
</div>
